import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Login from "./login/Login";
import LoginWithEmail from "./login/LoginWithEmail";
import Redirect from "./login/Redirect";
import CreateAccount from "./register/CreateAccount";
import ResetPassword from "./reset-password/ResetPassword";
// import SetNewPassword from "./reset-password/SetNewPassword";
import SetNewPassword from "./../../v2/pages/set-new-password/set-new-password.page";
import AccountCreated from "./login/AccountCreated";
import { LOCALES } from "common/constants";
import SignUpPage from "../../v2/pages/registration/signup.page";
import LoginWithEmail from "../../v2/pages/login/signin.page";
import ForgetPassword from "../../v2/pages/forget-password/forget-password.page";
// import BankIdLogin from "../../v2/pages/bankId-login/bankId-login"
import { useLocalizedRoutes } from "../../v2/hooks/useLocalizedRoutes";

const AuthView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  let language = localStorage.getItem("i18nextLng");
  const getQueryParams = (query) => {
    return new URLSearchParams(query);
  };

  const queryParams = getQueryParams(location.search);
  const invoiceNumber = queryParams.get("invoiceNumber");
  const isAuthorize = queryParams.get("isAuthorize") == "true";
  const { routes } = useLocalizedRoutes();

  useEffect(() => {
    if (
      user &&
      (location.pathname === "/login" ||
        location.pathname === "/logga-in" ||
        location.pathname === "/idlogin" ||
        location.pathname === "/emaillogin" ||
        location.pathname === "/e-postinloggning" ||
        location.pathname === "/emailregister" ||
        location.pathname === "/e-postregister" ||
        location.pathname === "/forgot-password" ||
        location.pathname === "/glomt-ditt-losenord" ||
        location.pathname === "/login/redirect")
    )

    if (invoiceNumber) {
      if (language === LOCALES.EN_US) {
        navigate(`/dashboard/economy/invoices?lang=${LOCALES.EN_US}&invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=${true}`);
      } else {
        navigate(`/instrumentbrada/ekonomi/fakturor?lang=${LOCALES.SV_SE}&invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=${true}`);
      }
    } else {
     if (language === LOCALES.EN_US) {
        navigate(`/dashboard/activities?lang=${LOCALES.EN_US}`);
      } else {
        navigate(`/instrumentbrada/aktiviteter?lang=${LOCALES.SV_SE}`);
      }
     
    }
  }, [user, navigate, location, language]);

  return (
    <Routes>
      <Route
        exact
        path={language === LOCALES.EN_US ? "/thankyou/:email" : "/tack/:email"}
        element={<AccountCreated />}
      />
      <Route
        exact
        path={routes.forgotPassword}
        element={<ForgetPassword />}
      />
      <Route
        exact
        path={routes.login}
        // element={<Login />}
        element={<LoginWithEmail />}
      />

      <Route
        exact
        path={routes.emailLogin}
        // path={language === LOCALES.EN_US ? "/emaillogin" : "/e-postinloggning"}
        // element={<LoginWithEmail />}
        element={<LoginWithEmail />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/emailregister" : "/e-postregister"}
        element={<CreateAccount />}
      // element={<SignUpPage />}
      />
      {/* <Route
        exact
        path={language === LOCALES.EN_US ? "/forgot-password" : "/glomt-ditt-losenord"}
        element={<ForgetPassword />}
      /> */}
      <Route
        exact
        path={routes.SetNewPassword}
      // element={<SetNewPassword />}
      element={<SetNewPassword />}

      />
      <Route exact path="/login/redirect" element={<Redirect />} />
    </Routes>
  );
};

export default AuthView;
